var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('svgicon',{attrs:{"src":"icon/tooltip.svg","height":14,"width":14}}),_c('div',{staticClass:"box",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }